/**
 * Company: Etton Group
 * User: Nikolay Zubkov
 * Date: 13.11.2021
 * Time: 22:47
 */

export default {
  data() {
    return {
      fields: {
        document_ids: [],
        files:        []
      }
    }
  },
  computed: {
    documentIds() {
      return this?.fields?.documents?.length ? this.fields.documents.map(({ id }) => id) : []
    },
  },
  methods: {
    documentsChanged({ ids = [], document = {}, deleted = null }) {
      this.$set(this.fields, 'document_ids', ids)
      
      if (document && Object.keys(document).length && document?.id) {
        this.fields.documents.push(document)
      }
      if (deleted !== null) {
        const idx = this.fields.documents.findIndex(({ id }) => id === deleted)
        if (idx !== -1) {
          this.fields.documents.splice(idx, 1)
        }
      }
    }
  }
}